import axios from "axios";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import SideBar from "./sidebar/ManagerSideBar";
import DashBoardNavbar from "./navbar/DashBoardNavbar";
import * as React from 'react';
import { styled } from '@mui/system';
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteFeed from "../Modals/DeleteFeed";
import EditIcon from "@mui/icons-material/Edit";
import Spinner, { DotLoader } from 'react-spinner-overlay';
import { useEffect } from 'react';
import "../../App.css"


import TablePagination, {
  tablePaginationClasses as classes,

} from '@mui/base/TablePagination';

// import viewLatestFeeds from "../Modals/viewLatestFeeds";
import NewFeedModal from "../Modals/NewFeedModal";
import '../pages/sidebar/Sidebar.css'

import { useNavigate } from 'react-router';
import AddIcon from "@mui/icons-material/Add";
import { showSuccessToast, showErrorToast } from "../../Utils/toastUtils";
import EditFeed from "../Modals/EditFeed";

function Feeds() {

  let navigate = useNavigate();
  const [user, setuser] = React.useState("");
  const [rows, setRows] = React.useState([]);
  const [rowsFilter, setRowsFilter] = React.useState([]);
  const [modal, setModal] = React.useState(false);
  const [modal1, setModal1] = React.useState(false);
  const [modal2, setModal2] = React.useState(false);
  const [modal3, setModal3] = React.useState(false);
  const [name, setName] = React.useState("");
  const [url, setUrl] = React.useState("");
  const [async, setAsync] = React.useState("Yes");
  const [feedType, setFeedType] = React.useState("MRSS");
  const [repeats, setRepeats] = React.useState("");
  const [data, setData] = React.useState([])
  const [durationFilterMin, setDurationFilterMin] = React.useState("");
  const [durationFilterMax, setDurationFilterMax] = React.useState("");
  const [sizeFilter, setSizeFilter] = React.useState("");
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
  const [currentID, setCurrentID] = React.useState("");
  const [feedData, setFeedData] = React.useState("");
  const [loading, setLoading] = React.useState(false);




  const getData = async () => {
    setLoading(true);
    setPage(0)
    console.log("getting the videos")
    // socket.emit('get-data');


    
    let data = await axios.get('/api/feeds/all', {
      headers: {
        Authorization: 'Bearer ' + sessionStorage.getItem('userToken')
      }
    })
      .then(response => {
        // Handle successful response
        console.log(response.data)
        setRows(response.data.reverse())
      })
      .catch(error => {
        // Handle error
        console.error(error);
      })

      .finally(() => {
          setLoading(false); // Set the loading state to false after the data is loaded or an error occurs
        });

  }

  const getIndividualFeedDetails = (id) => {
    let data = axios
      .get(`/api/feeds/feed/${id}`, {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("userToken"),
        },
      })
      .then((response) => {
        console.log(response.data);
        setFeedData(response.data);
        setName(response.data.title);
        setUrl(response.data.rssLink);
        setAsync(response.data.autoSync);
        setRepeats(response.data.repeats);
        setDurationFilterMin(response.data.filterDurationMin);
        setDurationFilterMax(response.data.filterDurationMax);
        setSizeFilter(response.data.filterSize);

      })
      .catch((err) => {
        console.log(err);

        showErrorToast("Error!");
      });
  };

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  React.useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const getFeedDetails = async (id) => {
    console.log("getting the individual videos")
    let data = await axios.get(`/api/feeds/feed/${id}`, {
      headers: {
        Authorization: 'Bearer ' + sessionStorage.getItem('userToken')
      }
    })
      .then(response => {
        // Handle successful response
        console.log(response.data)
        setData(response.data.videos)
        setModal1(!modal1)
      })
      .catch(error => {
        // Handle error
        console.error(error);
      });
  }

  React.useEffect(() => {
    getData();
  }, []);


  const deleteFeed = async (id) => {
    console.log("deleting the individual videos")
    let data = await axios.delete(`/api/feeds/feed/${id}`, {
      headers: {
        Authorization: 'Bearer ' + sessionStorage.getItem('userToken')
      }
    })
      .then(response => {
        // Handle successful response
        console.log(response.data)
        getData()
      })
      .catch(error => {
        // Handle error
        console.error(error);
      });

  }

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    showSuccessToast(`Rows Per Page changed to ${parseInt(event.target.value, 10)}`)
    setPage(0);
  };

  React.useEffect(() => {
    getData()

  }, [])
  const blue = {
    200: '#A5D8FF',
    400: '#3399FF',
  };

  const grey = {
    50: '#F3F6F9',
    100: '#E7EBF0',
    200: '#E0E3E7',
    300: '#CDD2D7',
    400: '#B2BAC2',
    500: '#A0AAB4',
    600: '#6F7E8C',
    700: '#3E5060',
    800: '#2D3843',
    900: '#1A2027',
  };

  const Root = styled('div')(
    ({ theme }) => `
    table {
      font-family: IBM Plex Sans, sans-serif;
      font-size: 0.875rem;
      border-collapse: collapse;
      width: 100%;
    }
  
    td,
    th {
      border: 1px solid ${theme.palette.mode === 'dark' ? grey[800] : grey[200]};
      text-align: left;
      padding: 6px;
    }
  
    th {
      background-color: ${theme.palette.mode === 'dark' ? grey[900] : grey[100]};
    }
    `,
  );

  const CustomTablePagination = styled(TablePagination)(
    ({ theme }) => `
    & .${classes.spacer} {
      display: none;
    }
  
    & .${classes.toolbar}  {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
  
      @media (min-width: 768px) {
        flex-direction: row;
        align-items: center;
      }
    }
  
    & .${classes.selectLabel} {
      margin: 0;
    }
  
    & .${classes.select}{
      padding: 2px;
      border: 1px solid ${theme.palette.mode === 'dark' ? grey[800] : grey[200]};
      border-radius: 50px;
      background-color: transparent;
  
      &:hover {
        background-color: ${theme.palette.mode === 'dark' ? grey[800] : grey[50]};
      }
  
      &:focus {
        outline: 1px solid ${theme.palette.mode === 'dark' ? blue[400] : blue[200]};
      }
    }
  
    & .${classes.displayedRows} {
      margin: 0;
  
      @media (min-width: 768px) {
        margin-left: auto;
      }
    }
  
    & .${classes.actions} {
      padding: 2px;
      border: 1px solid ${theme.palette.mode === 'dark' ? grey[800] : grey[200]};
      border-radius: 50px;
      text-align: center;
    }
  
    & .${classes.actions} > button {
      margin: 0 8px;
      border: transparent;
      border-radius: 2px;
      background-color: transparent;
  
      &:hover {
        background-color: ${theme.palette.mode === 'dark' ? grey[800] : grey[50]};
      }
  
      &:focus {
        outline: 1px solid ${theme.palette.mode === 'dark' ? blue[400] : blue[200]};
      }
    }
    `,
  );

  const logOut = () => {
    sessionStorage.clear();
    navigate('/login')

  }

  return (
    <body className={`overflow-hidden grad ${windowWidth <= 1200 ? "" : "g-sidenav-show"}`}>
      {/* side navbar */}
      {windowWidth >= 1200 && <SideBar />}
      <main className="main-content position-relative h-100 border-radius-lg">
        <DashBoardNavbar user={user} logOut={logOut}/>
        <div className="container-fluid py-4">
          <div className="row">
            <div className="col-12">
              <div className="card my-4">
                <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                  <div className="bg-gradient-info shadow-info border-radius-lg pt-4 pb-3">
                    <h6 className="text-white text-capitalize ps-3">
                      All Feeds
                    </h6>
                  </div>
                </div>
                <div className="card-body px-4 pb-2">
                  <div className="table-responsive p-0 d-flex justify-content-center align-items-center">
                    <Root sx={{ width: 1500, maxWidth: '100%' }}>
                    {loading ? (
                      <div class="d-flex justify-content-center m-3">
                <DotLoader
                    visible={loading}
                    textContent={'Loading...'}
                    animation="grow"
                    overlayColor="rgba(0, 0, 0, 0.5)"
                    color="#5BC0F8"
                    
                   />
                   </div>
                ) : (
                      <table aria-label="custom pagination table">
                        <thead>
                          <tr>
                            <th style={{ width: '5%' }} className="text-center">Sr No.</th>
                            <th style={{ width: '15%' }} className="text-center">Name</th>
                            <th style={{ width: '10%' }} className="text-center">Creation</th>
                            <th style={{ width: '15%' }} className="text-center">Last Import</th>
                            <th style={{ width: '10%' }} className="text-center">Auto Sync</th>
                            <th style={{ width: '15%' }} className="text-center">Repeats</th>
                            <th style={{ width: '10%' }} className="text-center">Type</th>
                            <th style={{ width: '10%' }} className="text-center">Videos</th>
                            <th style={{ width: '10%' }} className="text-center">Action</th>

                          </tr>
                        </thead>
                        <tbody>
                            {/* tempData */}
                          {
                            (rowsPerPage > 0
                              ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                              : rows
                            )
                              .map((row, index) => (
                                <tr key={row._id}>
                                  <td>{(index + 1) + (rowsPerPage * (page ))}</td>
                                  <td style={{ width: '15%' }} className="">
                                    {row.title ? row.title : "No Title Found"}

                                  </td>

                                  <td style={{ width: '20%' }} >{row.creation ? new Date(row.creation).toLocaleString() : "No Creation Found"}</td>
                                  <td style={{ width: '15%' }} >{row.schedulerId && row.schedulerId.lastImport ? new Date(row.schedulerId.lastImport).toLocaleString() : "No Last Import Found"}</td>
                                  <td style={{ width: '5%' }} >{row.autoSync ? row.autoSync : "No Auto Update"}</td> 
                                  <td style={{ width: '10%' }} >{row.repeats ? row.repeats : "No Repeats"}</td>
                                  <td style={{ width: '15%' }} >{row.type ? row.type : "No Category Given"}</td>
                                  <td style={{ width: '15%' }} >{row.videos ? row.videos : "No Videos"}</td>

                                  <td>{
                                    <div className="d-flex justify-content-center align-items-center">
                                    <button
                                    className="btn btn-link text-secondary mb-0"
                                  onClick={() => {
                                    getIndividualFeedDetails(row._id);
                                    setCurrentID(row._id);
                                    setModal1(true);
                                  }}
                                  >
                                    <EditIcon fontSize="small" color="action" />
                                  </button>
                                    <button
                                    className="btn btn-link text-secondary mb-0 d-flex justify-content-center align-items-center"
                                    onClick={() => {
                                      console.log("Clicked");
                                      // DeleteFeed(row._id);
                                      setCurrentID(row._id)
                                      setModal2(true);
                                    }}
                                  >
                                  
                                    <DeleteIcon color="action" />
                                  </button>
                                  
                                  </div>}</td>
                                  

                                </tr>
                                
                              ))}
                          {emptyRows > 0 && (
                            <tr style={{ height: 34 * emptyRows }}>
                              <td colSpan={3} />
                            </tr>
                          )}
                        </tbody>
                        <tfoot>
                          <tr>
                            <CustomTablePagination
                              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                              colSpan={3}
                              count={rows.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              slotProps={{
                                select: {
                                  'aria-label': 'rows per page',
                                },
                                actions: {
                                  showFirstButton: true,
                                  showLastButton: true,
                                },
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                          </tr>
                        </tfoot>
                       
                      </table>
                      )}
                    </Root>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <div
        style={{
          float: "right",
          marginRight: "20px",
          paddingTop: "15px",
        }}
      >

        <div
          className="fixed-bottom d-flex justify-content-end px-3"
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 9999,
            padding: "10px"
          }}
        >

          <button
            className="btn btn-info"
            onClick={() => setModal(!modal)}
            style={{ float: "left" }}

          >
            <AddIcon /> Create Feed
          </button>


          <span
            className="d-sm-inline d-none"
            style={{ marginLeft: "5px" }}
          ></span>
        </div>
      </div>
      <NewFeedModal
        getData={getData}
        modal={modal}
        setModal={setModal}
      />

      <DeleteFeed
        getData={getData}
        modal2={modal2}
        setModal2={setModal2}
        id={currentID}
      />

      <EditFeed
        getData={getData}
        modal3={modal3}
        setModal3={setModal3}
        modal1={modal1}
        setModal1={setModal1}
        name={name}
        url={url}
        feedType={feedType}
        autoSync={async}
        repeats={repeats}
        durationFilterMin={durationFilterMin}
        durationFilterMax={durationFilterMax}
        sizeFilter={sizeFilter}
        setName={setName}
        // setUrl={setUrl}
        setFeedType={setFeedType}
        setAsync={setAsync}
        setRepeats={setRepeats}
        setDurationFilterMin={setDurationFilterMin}
        setDurationFilterMax={setDurationFilterMax}
        setSizeFilter={setSizeFilter}
        // handleUpdate={handleUpdate}
        Root={Root}
        CustomTablePagination={CustomTablePagination}
        rowsPerPage={rowsPerPage}
        rows={rowsFilter}
        setRows={setRowsFilter}
        page={page}
        emptyRows={emptyRows}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        currentID={currentID}
      />


    </body >
  );
}

export default Feeds;